import { t } from '@procumi/shared';
import { useState } from 'react';

/**
 * Categoriile unui furnizor: etichete pe care le scoți cu ×, plus un câmp cu
 * sugestii pentru a adăuga. Sugestiile sunt categoriile deja folosite de firmă,
 * dar poți scrie orice altceva.
 */
export function CategoryPicker({
  value,
  suggestions,
  onChange,
}: {
  value: string[];
  suggestions: string[];
  onChange: (next: string[]) => void;
}) {
  const [draft, setDraft] = useState('');

  const add = (raw: string) => {
    const name = raw.trim().replace(/\s+/g, ' ');
    if (!name) return;
    if (!value.some((v) => v.toLowerCase() === name.toLowerCase())) onChange([...value, name]);
    setDraft('');
  };

  const free = suggestions.filter((s) => !value.some((v) => v.toLowerCase() === s.toLowerCase()));

  return (
    <div className="picker">
      {value.length ? (
        <div className="chips">
          {value.map((c) => (
            <span className="chip" key={c}>
              {c}
              <button
                type="button"
                aria-label={t('Scoate categoria {0}', c)}
                onClick={() => onChange(value.filter((x) => x !== c))}
              >
                ×
              </button>
            </span>
          ))}
        </div>
      ) : (
        <p className="hint" style={{ margin: 0 }}>
          {t('Alege cel puțin o categorie.')}
        </p>
      )}

      <div className="picker-add">
        <input
          className="inp"
          list="category-suggestions"
          value={draft}
          placeholder={t('Adaugă categorie')}
          aria-label={t('Adaugă categorie')}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              add(draft);
            }
          }}
        />
        <datalist id="category-suggestions">
          {free.map((s) => (
            <option key={s} value={s} />
          ))}
        </datalist>
        <button type="button" className="btn small" onClick={() => add(draft)}>
          {t('Adaugă')}
        </button>
      </div>
    </div>
  );
}
